import * as React from 'react';
import { PageChorinitia } from '../genericComponents/Page/PageChorinitia';
import { UserRole } from '../../types/UserRole';
import { ListCourse } from './internalComponents/ListCourse';
import { ButtonDeconnect }  from './internalComponents/ButtonDeconnect';
import LoginServices from '../../services/LoginServices';
import Axios from 'axios';

/**
 * Ce composant permet d'afficher la page du superAdmin
 */
export class SuperAdminPage extends React.Component {
    render() {
        return (
            <PageChorinitia
                allowedUsers={[
                    UserRole.SUPER_ADMIN
                ]}
            >
                <div>
                    <ButtonDeconnect/>
                    <button
                        className="btn btn-outline-secondary font-weight-bold"
                        style={{marginTop: '20px', marginBottom: '20px'}}
                        onClick={this.offline}
                    >
                        Mettre le site hors-ligne
                    </button>
                    <ListCourse />
                </div>
            </PageChorinitia>
        );
    }

    private offline = () => {
        const token = LoginServices.getInstance().getUserToken();
        return (Axios.get(
            process.env.REACT_APP_OFFLINE_URL!,
            {
                headers: {
                    'X-Access-Token': token
                },
            }
        ).then(
            () => { return; }
        ));
    }
}


// WEBPACK FOOTER //
// ./src/components/SuperAdminPage/SuperAdminPage.tsx